const bodyBuildingFAQ = [
  {
    id: 1,
    question: "کلاس ها چگونه برگزار می شود؟",
    answer: [
      "کلاس ها در ساعات تعیین شده به صورت لایو در اینستاگرام برگزار می‌شود بعد از ثبت نام و دریافت لینک ، می‌توانید وارد کلاس خود شوید در صورتی که به صورت لایو در کلاس شرکت نکنید ،  تمرین ها بعد از هر جلسه در فضای کلود ، تا پایان ترم سیو می‌شود و می‌توانید به صورت آفلاین از جلسات استفاده نمایید"
    ]
  },
  {
    id: 2,
    question: "فرق بین دوره حرفه ای و مبتدی ",
    answer: [
      "اگر سابقه تمرینی دارید و از سلامت کامل برخوردارید می‌توانید در کلاس پیشرفته شرکت نمایید در صورت نداشتن سابقه تمرینی و آسیب های جزئی که بعضا به دلیل ضعف عضلات است، با تایید پزشک متخصص میتوانید در کلاس مبتدی شرکت نمایید. در کلاس مبتدی ، تمرین ها سطح بندی شده و توضیحات آموزشی داده می‌شود."
    ]
  },
  {
    id: 3,
    question: "چه وسایل و ابزاری نیاز هست؟",
    answer: [
      "این کلاس، یک کلاس عمومی است، از این جهت تمرین ها بیشتر با وزن بدن و در نهایت با استفاده از یک اضافه بار ، که می‌تواند دمبل، بطری یا هر وسیله جایگزین باشد طراحی می‌شود البته که دمبل ایمن تر می‌باشد."
    ]
  },
  {
    id: 4,
    question: "چجوری از کیفیت کلاس ها مطمئن شویم؟",
    answer: [
      "هایلایت رضایت شما و هایلایت نتایج رو داخل پیج اینستاگرام ببینید و با خیال راحت داخل کلاس شرکت کنید"
    ]
  },
  {
    id: 5,
    question: "پشتیبانی کلاس ها چگونه است؟",
    answer: [
      "اگر به صورت لایو شرکت می‌کنید، سر کلاس ، کامنت ها باز هست و هر سوالی مستقیما توسط مربی پاسخ داده میشه در غیر این صورت از طریق آیکون ایمیل در قسمت بالای سمت راست اپلیکیشن می‌توانید با مربی خود در ارتباط باشید."
    ]
  },
];

export default bodyBuildingFAQ;